export default "__VITE_PUBLIC_ASSET__8d4309fc__"